import { render, staticRenderFns } from "./HistoryBlock.vue?vue&type=template&id=4841c0ec"
import script from "./HistoryBlock.vue?vue&type=script&lang=js"
export * from "./HistoryBlock.vue?vue&type=script&lang=js"
import style0 from "./HistoryBlock.vue?vue&type=style&index=0&id=4841c0ec&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4841c0ec')) {
      api.createRecord('4841c0ec', component.options)
    } else {
      api.reload('4841c0ec', component.options)
    }
    module.hot.accept("./HistoryBlock.vue?vue&type=template&id=4841c0ec", function () {
      api.rerender('4841c0ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invention/HistoryBlock.vue"
export default component.exports